import type { FaireProductEntity } from "../../entity_types/product";

export const p_fdv95y6qn9: FaireProductEntity = {
  token: "p_fdv95y6qn9",
  type: "product",
  name: "Saltwater Jasmine - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/59873d65287e132f5225dc0b15f245f768201935fe762d8be9d422f7dbe2077b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f6de86a6208a560edce5512ad62c7a12cfc8e75e53b1d476c38dcab101be4d1.png",
    "https://cdn.faire.com/fastly/98707e26e178942e29ea8ad65a5f2033fa5191a6c6ac5f94a450196c4e506d42.png",
    "https://cdn.faire.com/fastly/e8a013b6efad38b060d45e539c24d9a2228ae6b36388c4387a8374af60f6f3d8.jpeg",
    "https://cdn.faire.com/fastly/dac936c136439e5dce69e03119836478cc75f67ed6e18fbb647f4cc77b7208c7.jpeg",
    "https://cdn.faire.com/fastly/ad63abf533efb8e446d6e574db7a04e8d7ec6d0b3c4bd68452a72b1d759d1a8a.jpeg",
  ],
  priceDollars: 11,
  description:
    "Coastal mornings blanketed in a gentle marine layer, the warmth of the rising sun, wild white blossoms collecting dew. Ozonic, crisp, clean, with bergamot, muguet, sea moss, and sandalwood. \n\n Our best-selling 7.2 oz Standard Size. This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:47.176Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
